module.exports = __webpack_public_path__ + "img/logo-menu.43dbb537.png";